@if (subscription) {
  <!-- Unmanaged -->
  @if (
    !subscription.isManaged &&
    ((addingAssetsCount > 0 && isAssetLimitReached) ||
      (addingRegistersCount > 0 && isRegisterLimitReached))
  ) {
    <app-alert type="warning">
      <h4>Subscription Limit</h4>
      @if (addingAssetsCount > 0) {
        @if (singleAsset) {
          <p>
            You've reached the total asset limit
            @if (subscription.packageName) {
              of <span>{{ subscription.packageMaxAssets }}</span>
            }
            for your subscription.
          </p>
        }
        @if (!singleAsset) {
          <p>
            Adding additional assets will exceed your total asset limit
            @if (subscription.packageName) {
              of <span>{{ subscription.packageMaxAssets }}</span>
            }
            for your subscription.
          </p>
        }
      }
      @if (addingRegistersCount > 0) {
        <p>
          You've reached the total register limit
          @if (subscription.packageName) {
            of <span>{{ subscription.packageMaxRegisters }}</span>
          }
          for your subscription.
        </p>
      }
      @if (!subscription.isManaged) {
        <ng-template
          [authorizeShowElse]="NotOwner"
          [authorizeOrganisation]="
            OrganisationPermissionType.UpdateSubscription
          "
        >
          <button
            data-dd-action-name="subscription-limit.upgrade-button"
            type="button"
            class="btn btn-primary"
            (click)="upgradeSubscription()"
          >
            Upgrade Subscription
          </button>
        </ng-template>
        <ng-template #NotOwner>
          <p>
            A user with sufficient privileges can upgrade your subscription.
          </p>
        </ng-template>
      }
    </app-alert>
  }

  <!-- Trials -->
  @if (!subscription.isManaged && subscription.isPeriodBasedTrialExpired) {
    <app-alert type="warning">
      <ng-container>
        <p>
          Your Trial Period expired on
          <b>{{ subscription.subscriptionExpires | date }}</b>
        </p>
        <p>
          But it's not too late to take the next step. You can take all
          {{ subscription.totalAssets }}
          Assets you created in the trial to a paid subscription.
        </p>

        <ng-template
          [authorizeShowElse]="NotPermission"
          [authorizeOrganisation]="
            OrganisationPermissionType.UpdateSubscription
          "
        >
          <button
            data-dd-action-name="subscription-limit.upgrade-options-button"
            type="button"
            class="btn btn-primary"
            (click)="upgradeSubscription()"
          >
            See Upgrade Options
          </button>
        </ng-template>

        <ng-template #NotPermission>
          <p>Ask your account admin to update your subscription.</p>
        </ng-template>
      </ng-container>
    </app-alert>
  }

  <!-- Managed -->
  @if (subscription.isManaged && addingAssetsCount > 0 && isAssetLimitReached) {
    <p class="text-warning">
      You've reached the total asset limit
      @if (subscription.packageName) {
        of <span>{{ subscription.packageMaxAssets }}</span>
      }
      for your subscription.
      <a
        data-dd-action-name="subscription-limit.contact-us-link"
        href="https://www.finquery.com"
        class="link"
        target="_blank"
        >Contact us.
      </a>
    </p>
  }
  @if (
    subscription.isManaged && addingRegistersCount > 0 && isRegisterLimitReached
  ) {
    <p class="text-warning">
      You've reached the total register limit
      @if (subscription.packageName) {
        of
        <span>{{ subscription.packageMaxRegisters }}</span>
      }
      for your subscription.
      <a
        data-dd-action-name="subscription-limit.contact-us-link"
        href="https://www.finquery.com"
        class="link"
        target="_blank"
        >Contact us.
      </a>
    </p>
  }
}
